<template>
  <main class="flex w-full bg-[#f1f3ff]">
    <!-- <LeftNav /> -->

    <section
      class="flex flex-col overflow-hidden w-full transition-all duration-300"
    >
      <!-- <TopNav /> -->
      <Header />
      <div
        class="bg-[#F9FAFF] p-6 h-[calc(100vh-100px)] overflow-auto mx-3 rounded-[30px] flex flex-col gap-3 2xl:gap-5 page-wrapper"
      >
        <!-- Header -->
        <div class="flex flex-col md:flex-row md:justify-between gap-3 md:items-center py-5 mb-2">
          <div class="text-lg font-semibold text-gray-700">
            Tickets
            <span class="text-sm font-normal text-gray-400 ml-2"
              >({{ totalCount }})</span
            >
          </div>
          <div class="flex gap-3 flex-wrap">
            <button
              @click="isTicketModalOpen = true"
              class="px-4 py-2 rounded-md bg-blues hover:bg-hover text-white text-sm whitespace-nowrap"
            >
              Raise Ticket
            </button>
            <!-- Search -->
            <input
              v-model="search"
              type="text"
              placeholder="Search by title..."
              class="py-2 px-3 border text-xs border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#76bdeb] w-44"
            />

            <!-- Type filter -->
            <select
              @change="handleFilters"
              v-model="filterType"
              class="py-2 px-3 border text-xs border-gray-300 bg-white rounded-lg shadow-sm focus:outline-none"
            >
              <option value="">All Types</option>
              <option value="bug">Bug / Issue</option>
              <option value="feature">Feature Request</option>
              <option value="support">General Support</option>
              <option value="other">Other</option>
            </select>

            <!-- Priority filter -->
            <select
              @change="handleFilters"
              v-model="filterPriority"
              class="py-2 px-3 border text-xs border-gray-300 bg-white rounded-lg shadow-sm focus:outline-none"
            >
              <option value="">All Priorities</option>
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="critical">Critical</option>
            </select>

            <!-- Status filter -->
            <select
              @change="handleFilters"
              v-model="filterStatus"
              class="py-2 px-3 border text-xs border-gray-300 bg-white rounded-lg shadow-sm focus:outline-none"
            >
              <option value="">All Statuses</option>
              <option value="open">Open</option>
              <option value="in_progress">In Progress</option>
              <option value="awaiting_client">Awaiting Client</option>
              <option value="resolved">Resolved</option>
              <option value="closed">Closed</option>
            </select>

            <!-- Clear -->
            <button
              @click="clearFilters"
              class="py-2 px-3 border text-xs border-gray-300 bg-gray-100 hover:bg-gray-200 rounded-lg shadow-sm"
            >
              Clear
            </button>
          </div>
        </div>

        <!-- Loading -->
        <div v-if="loading" class="flex justify-center items-center py-16">
          <svg
            class="animate-spin h-8 w-8 text-[#76bdeb]"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
        </div>

        <!-- Error -->
        <div v-else-if="error" class="text-center py-12 text-red-500 text-sm">
          {{ error }}
        </div>

        <!-- Empty -->
        <div
          v-else-if="tickets.length === 0"
          class="text-center py-12 text-gray-400 text-sm"
        >
          No tickets found.
        </div>

        <!-- Table -->
        <div v-else class="overflow-x-auto">
          <table class="min-w-full border-collapse text-start">
            <thead>
              <tr>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  S.No
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Ticket #
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Title
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Type
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Priority
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Status
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Raised By
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Module
                </th>
                <th
                  class="px-3 border border-gray-300 py-3 text-xs font-bold uppercase text-start text-textblues"
                >
                  Created
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr
                v-for="(ticket, index) in tickets"
                :key="ticket.id"
                class="hover:bg-blue-50 transition-colors border-b border-gray-100 cursor-pointer"
                @click="
                  $router.push({
                    name: 'TicketDetail',
                    params: { id: ticket.id },
                  })
                "
              >
                <td
                  class="px-3 py-3 border border-gray-200 text-xs text-gray-500"
                >
                  {{ (currentPage - 1) * pageSize + index + 1 }}
                </td>
                <td
                  class="px-3 py-3 border border-gray-200 text-xs font-medium text-[#76bdeb] whitespace-nowrap"
                >
                  {{ ticket.ticket_number }}
                </td>
                <td
                  class="px-3 py-3 border border-gray-200 text-xs text-gray-700 max-w-[220px]"
                >
                  <p class="line-clamp-2">{{ ticket.title }}</p>
                </td>
                <td class="px-3 py-3 border border-gray-200 text-xs">
                  <span
                    :class="typeClass(ticket.ticket_type)"
                    class="px-2 py-1 rounded-full text-[10px] font-medium capitalize"
                  >
                    {{ typeLabel(ticket.ticket_type) }}
                  </span>
                </td>
                <td class="px-3 py-3 border border-gray-200 text-xs">
                  <span
                    :class="priorityClass(ticket.priority)"
                    class="px-2 py-1 rounded-full text-[10px] font-medium capitalize"
                  >
                    {{ ticket.priority }}
                  </span>
                </td>
                <td class="px-3 py-3 border border-gray-200 text-xs">
                  <span
                    :class="statusClass(ticket.status)"
                    class="px-2 py-1 rounded-full text-[10px] font-medium whitespace-nowrap"
                  >
                    {{ statusLabel(ticket.status) }}
                  </span>
                </td>
                <td
                  class="px-3 py-3 border border-gray-200 text-xs text-gray-600"
                >
                  {{ ticket.raised_by || "—" }}
                </td>
                <td
                  class="px-3 py-3 border border-gray-200 text-xs text-gray-600"
                >
                  {{ ticket.module || "—" }}
                </td>
                <td
                  class="px-3 py-3 border border-gray-200 text-xs text-gray-500 whitespace-nowrap"
                >
                  {{ formatDate(ticket.created_at) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div
          v-if="totalPages > 1"
          class="flex items-center justify-between mt-5 flex-wrap gap-3"
        >
          <p class="text-xs text-gray-400">
            Showing
            {{ (currentPage - 1) * pageSize + 1 }}–{{
              Math.min(currentPage * pageSize, totalCount)
            }}
            of {{ totalCount }} tickets
          </p>
          <div class="flex items-center gap-1">
            <button
              @click="goToPage(currentPage - 1)"
              :disabled="currentPage === 1"
              class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-40"
            >
              Prev
            </button>
            <template v-for="p in totalPages" :key="p">
              <button
                v-if="
                  p === 1 || p === totalPages || Math.abs(p - currentPage) <= 1
                "
                @click="goToPage(p)"
                :class="
                  p === currentPage
                    ? 'bg-blues text-white border-transparent'
                    : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
                "
                class="px-3 py-1.5 text-xs rounded-lg border"
              >
                {{ p }}
              </button>
              <span
                v-else-if="p === currentPage - 2 || p === currentPage + 2"
                class="px-1 text-gray-400 text-xs"
                >…</span
              >
            </template>
            <button
              @click="goToPage(currentPage + 1)"
              :disabled="currentPage === totalPages"
              class="px-3 py-1.5 text-xs rounded-lg border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-40"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </section>
    <RaiseTicket
      :isVisible="isTicketModalOpen"
      @close="
        () => {
          fetchTickets();
          isTicketModalOpen = false;
        }
      "
    />
  </main>
</template>

<script>
import axios from "axios";
import Header from "@/components/Admin/Header.vue";

// import LeftNav from "@/components/LeftNav.vue";
// import TopNav from "@/components/TopNav.vue";
import RaiseTicket from "@/components/Tickets/RaiseTicket.vue";
import { mapGetters } from "vuex";

const ECOAUTH_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb21haW4iOiJwbXMuY2hhZHVyYS5jb20iLCJ1c2VyX2lkIjo2LCJleHAiOjE4NzQwNTA5NDZ9._M_j0Xe6wxhT5ckdrQsf9BLhcCblw1BesfQEKb4X8R4";
let searchTimer = null;

export default {
  name: "TicketList",
  components: {
    // LeftNav,
    // TopNav,
    Header,
    RaiseTicket,
  },
  data() {
    return {
      tickets: [],
      loading: false,
      error: "",
      search: "",
      filterType: "",
      filterPriority: "",
      filterStatus: "",
      isTicketModalOpen: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  watch: {
    filterType() {
      this.currentPage = 1;
      this.fetchTickets();
    },
    filterPriority() {
      this.currentPage = 1;
      this.fetchTickets();
    },
    filterStatus() {
      this.currentPage = 1;
      this.fetchTickets();
    },
    search() {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.fetchTickets();
      }, 400);
    },
  },
  computed: {
    ...mapGetters(["getUserInfo", "getRoleLevel","userInfo"]),
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize) || 1;
    },
  },
  created() {
    this.fetchTickets();
  },
  methods: {
    async fetchTickets() {
      this.loading = true;
      this.error = "";
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize,
        };
        if (this.search) params.search = this.search;
        if (this.filterType) params.ticket_type = this.filterType;
        if (this.filterPriority) params.priority = this.filterPriority;
        if (this.filterStatus) params.status = this.filterStatus;

        // const v =
        //   this.userInfo.user.permission == "super_admin"
        //     ? `&raised_by=${this.userInfo.user.email}`
        //     : "";

        const response = await axios.get(
          `${process.env.VUE_APP_TICKET_URL}/tickets/list/?project_code=AUO-LMS`,
          { headers: { ecoauth: ECOAUTH_TOKEN }, params },
        );
        if (response.data.success) {
          this.tickets = response.data.data;
          this.totalCount = response.data.count ?? this.tickets.length;
        } else {
          this.error = response.data.message || "Failed to load tickets.";
        }
      } catch (err) {
        this.error = "Failed to load tickets. Please try again.";
      } finally {
        this.loading = false;
      }
    },
    goToPage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.fetchTickets();
    },
    clearFilters() {
      this.search = "";
      this.filterType = "";
      this.filterPriority = "";
      this.filterStatus = "";
    },
    formatDate(dateStr) {
      if (!dateStr) return "—";
      return new Date(dateStr).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    },
    typeLabel(type) {
      const map = {
        bug: "Bug",
        feature: "Feature",
        support: "Support",
        other: "Other",
      };
      return map[type] || type;
    },
    statusLabel(status) {
      const map = {
        open: "Open",
        in_progress: "In Progress",
        awaiting_client: "Awaiting Client",
        resolved: "Resolved",
        closed: "Closed",
      };
      return map[status] || status;
    },
    priorityClass(priority) {
      return (
        {
          low: "bg-gray-100 text-gray-600",
          medium: "bg-blue-100 text-blue-700",
          high: "bg-orange-100 text-orange-700",
          critical: "bg-red-100 text-red-700",
        }[priority] || "bg-gray-100 text-gray-600"
      );
    },
    statusClass(status) {
      return (
        {
          open: "bg-yellow-100 text-yellow-700",
          in_progress: "bg-blue-100 text-blue-700",
          awaiting_client: "bg-purple-100 text-purple-700",
          resolved: "bg-green-100 text-green-700",
          closed: "bg-gray-100 text-gray-500",
        }[status] || "bg-gray-100 text-gray-600"
      );
    },
    typeClass(type) {
      return (
        {
          bug: "bg-red-100 text-red-700",
          feature: "bg-indigo-100 text-indigo-700",
          support: "bg-teal-100 text-teal-700",
          other: "bg-gray-100 text-gray-600",
        }[type] || "bg-gray-100 text-gray-600"
      );
    },
  },
};
</script>
